import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

/**
 *	Menu
 */
export function Menu() {
  // preklady
  const { t } = useTranslation();

  return (
    <Nav id="main-menu" className="ms-auto">
      <NavLink className="nav-link" to="/dev/applications">
        {t("dev.menu.applications")}
      </NavLink>
      <NavLink className="nav-link" to="/dev/docs">
        {t("dev.menu.documentation")}
      </NavLink>
      <NavLink className="nav-link" to="/dev/profile">
        {t("dev.menu.profile")}
      </NavLink>
    </Nav>
  );
}
